import { render, staticRenderFns } from "./TabMobileIntro.vue?vue&type=template&id=2a6f057a&scoped=true"
import script from "./TabMobileIntro.vue?vue&type=script&lang=js"
export * from "./TabMobileIntro.vue?vue&type=script&lang=js"
import style0 from "./TabMobileIntro.vue?vue&type=style&index=0&id=2a6f057a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6f057a",
  null
  
)

export default component.exports